import * as agGrid from 'ag-grid-angular';
import * as agGridEnterprise from 'ag-grid-enterprise';

window["ag-grid-angular"] = agGrid;
window["ag-grid-enterprise"] = agGridEnterprise;

export { agGrid, agGridEnterprise };